import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./store/store";
import PersistProvider from "./store/providers/persist-provider";
import "./assets/scss/style.scss";
import "./i18n";
import "animate.css";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Provider store={store}>
      <PersistProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </PersistProvider>
    </Provider>
  </StrictMode>
);
